import request, {downloadFile, getPDF, getImage, baseRequest} from 'tools/request'
import queryString from 'query-string'

export const SET_APPLICANTS_LIST = 'SET_APPLICANTS_LIST'
export const SET_APPLICANT_BYID = 'SET_APPLICANT_BYID'
export const SET_FMCSA_DATA = 'SET_FMCSA_DATA'
export const FORM_MODE = 'FORM_MODE'
export const RESET_FMCSA = 'RESET_FMCSA'
export const RESET_FMCSA_DATA = 'RESET_FMCSA_DATA'
export const NOTES_LIST = 'NOTES_LIST'
export const SET_VERIFICATION_LIST = 'SET_VERIFICATION_LIST'
export const SET_VERIFICATION_REPORT = 'SET_VERIFICATION_REPORT'
export const UCC_INTERACTION_LIST = 'UCC_INTERACTION_LIST'
export const SET_UCC_SEARCH_DATA = 'SET_UCC_SEARCH_DATA'
export const SET_UCC_RESPONSE = 'SET_UCC_RESPONSE'
export const SET_UCC_SEARCH_PARAMETERS = 'SET_UCC_SEARCH_PARAMETERS'
export const SET_UCC_SEARCH_ID = 'SET_UCC_SEARCH_ID'
export const SET_UCC_SEARCH_INDEX_DATE = 'SET_UCC_SEARCH_INDEX_DATE'
export const SET_UCC_SEARCH_HISTORY_DATA = 'SET_UCC_SEARCH_HISTORY_DATA'
export const SET_DOCUMENT_STATUS = 'SET_DOCUMENT_STATUS'
export const SET_RETRIEVE_DOCUMENTS = 'SET_RETRIEVE_DOCUMENTS'
export const SET_ATTACHMENTS_LIST = 'SET_ATTACHMENTS_LIST'
export const SET_BANK_TRANSACTIONS_LIST = 'SET_BANK_TRANSACTIONS_LIST'
export const SET_RECURRENT_BANK_TRANSACTIONS_LIST = 'SET_RECURRENT_BANK_TRANSACTIONS_LIST'
export const SET_ASSETS_REPORT_DATA = 'SET_ASSETS_REPORT_DATA'
export const SET_ASSETS_REPORT_TRANSACTIONS = 'SET_ASSETS_REPORT_TRANSACTIONS'
export const RESET_ASSETS_REPORT_DATA = 'RESET_ASSETS_REPORT_DATA'
export const SET_FILING_ATTACHMENTS_LIST = 'SET_FILING_ATTACHMENTS_LIST'
export const SET_CREDIT_LIST = 'SET_CREDIT_LIST'
export const SET_CREDIT_SEARCH_RESULT = 'SET_CREDIT_SEARCH_RESULT'
export const SET_CREDIT_REPORT_RESULT = 'SET_REPORT_CREDIT_RESULT'
export const SET_BGV_LIST = 'SET_BGV_LIST'
export const SET_CONNECTED_BUISNESS_LIST = 'SET_CONNECTED_BUISNESS_LIST'
export const SET_BGV_SEARCH_RESULT = 'SET_BGV_SEARCH_RESULT'
export const SET_DETAILED_BUSINESS_REPORT = 'SET_DETAILED_BUSINESS_REPORT'
export const SET_CONNECTED_BUSINESS_REPORT = 'SET_CONNECTED_BUSINESS_REPORT'
export const SET_UCC_FILING_LIST = 'SET_UCC_FILING_LIST'
export const SET_DIRECT_AMENDMENT_LIST = 'SET_DIRECT_AMENDMENT_LIST'
export const SET_TEMPLATES_LIST = 'SET_TEMPLATES_LIST'
export const SET_UCC_PREVIEW = 'SET_UCC_PREVIEW'
export const SET_UCC3_PREVIEW = 'SET_UCC3_PREVIEW'
export const SET_AMENDMENT_PREVIEW = 'SET_AMENDMENT_PREVIEW'
export const SET_ACTIVE_LIST = 'SET_ACTIVE_LIST'
export const SET_DEBTORS = 'SET_DEBTORS'
export const SET_TEMP_FILES_LIST = 'SET_TEMP_FILES_LIST'
export const SET_FORM_VALUES = 'SET_FORM_VALUES'
export const SET_UCC_FILTERS = 'SET_UCC_FILTERS'
export const SET_SOS_DATA = 'SET_SOS_DATA'
export const UPDATE_SUMMARY_CARD = 'UPDATE_SUMMARY_CARD'
export const UPDATE_DIRECT_AMENDMENTS = 'UPDATE_DIRECT_AMENDMENTS'
export const SET_MEMO_STATUS = 'SET_MEMO_STATUS';
export const SET_ALL_DATA_STATUS = 'SET_ALL_DATA_STATUS';
export const SET_MESSAGES_LIST = 'SET_MESSAGES_LIST';
export const SEND_MESSAGE_SUCCESS = 'SEND_MESSAGE_SUCCESS';

export const dispatchApplicantsList = (data, headers) => ({
    type: SET_APPLICANTS_LIST,
    data,
    headers
})

export const dispatchApplicantById = (data) => ({
    type: SET_APPLICANT_BYID,
    data
})

//uuid its the interaction uuid of the search
export const dispatchFmcsaData = (data, param, extraContent, uuid) => ({
    type: SET_FMCSA_DATA,
    data,
    extraContent,
    param,
    uuid
})
export const resetFmcsaData = () => ({
    type: RESET_FMCSA_DATA
})

export const dispatchFormMode = (data) => ({
    type: FORM_MODE,
    data
})

export const resetFmcsa = () => ({
    type: RESET_FMCSA
})

export const resetAssetsReportData = () => ({
    type: RESET_ASSETS_REPORT_DATA
})

export const dispatchNotesList = (data) => ({
    type: NOTES_LIST,
    data
})

export const dispatchMessagesList = (data) => ({
    type: SET_MESSAGES_LIST,
    data
})

export const dispatchSendMessageSuccess = (data) => ({
    type: SEND_MESSAGE_SUCCESS,
    data
})

const dispatchVerificationList = data => ({
    type: SET_VERIFICATION_LIST,
    data
})

const dispatchVerificationReport = data => ({
    type: SET_VERIFICATION_REPORT,
    data
})

export const dispatchUCCInteractionList = (data, search) => ({
    type: UCC_INTERACTION_LIST,
    data,
    search
})

export const dispatchUCCSearchData = (data, savedData = false) => ({
    type: SET_UCC_SEARCH_DATA,
    data,
    savedData
})

export const dispatchUccResponse = (data) => ({
    type: SET_UCC_RESPONSE,
    data
})

export const dispatchSearchParameters = (data) => ({
    type: SET_UCC_SEARCH_PARAMETERS,
    data
})

export const dispatchUCCSearchId = (data) => ({
    type: SET_UCC_SEARCH_ID,
    data
})

export const dispatchUCCSearchIndexDate = (data) => ({
    type: SET_UCC_SEARCH_INDEX_DATE,
    data
})

export const dispatchUCCSearchHistory = (data) => ({
    type: SET_UCC_SEARCH_HISTORY_DATA,
    data
})

export const dispatchDocumentStatus = (data, fileNumber) => ({
    type: SET_DOCUMENT_STATUS,
    data,
    fileNumber
})

export const dispatchRetrieveDocuments = (data) => ({
    type: SET_RETRIEVE_DOCUMENTS,
    data,
})

export const dispatchCreditList = (data) => ({
    type: SET_CREDIT_LIST,
    data
})

export const dispatchCreditSearchResult = (data) => ({
    type: SET_CREDIT_SEARCH_RESULT,
    data
})

export const dispatchCreditReportResult = (data) => ({
    type: SET_CREDIT_REPORT_RESULT,
    data
})

export const dispatchBgvList = (data) => ({
    type: SET_BGV_LIST,
    data
})

export const dispatchConnectedBuisnessList = (data) => ({
    type: SET_CONNECTED_BUISNESS_LIST,
    data
})

export const dispatchBgvSearchResult = (data) => ({
    type: SET_BGV_SEARCH_RESULT,
    data
})

export const dispatchDetailedBusinessReport = (data) => ({
    type: SET_DETAILED_BUSINESS_REPORT,
    data
})

export const dispatchConnectedBusinessReport = (data) => ({
    type: SET_CONNECTED_BUSINESS_REPORT,
    data
})

export const dispatchAttachmentList = (data, headers) => ({
    type: SET_ATTACHMENTS_LIST,
    data,
    headers
})

export const dispatchListOfBankTransactions = (data, headers) => ({
    type: SET_BANK_TRANSACTIONS_LIST,
    data,
    headers
})

export const dispatchListOfRecurrentBankTransactions = (data, headers) => ({
    type: SET_RECURRENT_BANK_TRANSACTIONS_LIST,
    data,
    headers
})

export const dispatchAssetsReportData = (data) => ({
    type: SET_ASSETS_REPORT_DATA,
    payload: data
})

export const dispatchAssetsReportTransactions = (data, headers) => ({
    type: SET_ASSETS_REPORT_TRANSACTIONS,
    payload: data,
    headers
})

export const dispatchFilingList = (data) => ({
    type: SET_UCC_FILING_LIST,
    data
})

export const dispatchDirectAmendmentList = (data) => ({
    type: SET_DIRECT_AMENDMENT_LIST,
    data
})

export const dispatchTemplateList = (data) => ({
    type: SET_TEMPLATES_LIST,
    data
})

export const dispatchUCCPreview = (data) => ({
    type: SET_UCC_PREVIEW,
    data
})

export const dispatchUCC3Preview = (data) => ({
    type: SET_UCC3_PREVIEW,
    data
})

export const dispatchAmendmentPreview = (data) => ({
    type: SET_AMENDMENT_PREVIEW,
    data
})

export const dispatchActiveList = (data, headers) => ({
    type: SET_ACTIVE_LIST,
    data,
    headers,
})

export const dispatchUccFilters = (filters = {}, freeSearch = '') => ({
    type: SET_UCC_FILTERS,
    filters,
    freeSearch
})

export const dispatchDebtors = (data) => ({
    type: SET_DEBTORS,
    data
})

export const dispatchTempFilesList = (data, headers) => ({
    type: SET_TEMP_FILES_LIST,
    data,
    headers
})

export const dispatchFormValues = (data) => ({
    type: SET_FORM_VALUES,
    data
})

export const dispatchSosData = (data) => ({
    type: SET_SOS_DATA,
    data,
})

export const dispatchUpdateSummaryCard = () => ({
    type: UPDATE_SUMMARY_CARD
})

export const dispatchUpdateDirectAmendments = () => ({
    type: UPDATE_DIRECT_AMENDMENTS
})

export const dispatchMemoStatus = (data) => ({
    type: SET_MEMO_STATUS,
    data
});

export const dispatchAllDataStatus = (data) => ({
    type: SET_ALL_DATA_STATUS,
    data
});

// get applicants list
export const getApplicantsList = (pagination = {}, filters = {}, demoMode = false) => async (dispatch, getState) => {

    if (pagination?.orderBy?.field) {
        switch (pagination?.orderBy?.field) {
            case 'createdBy':
                pagination.orderBy.field = 'createdBy_firstName'
                break;
            case 'salesRepresentative':
                pagination.orderBy.field = 'salesRepresentative_firstName'
                break;
            case 'applicantName':
                pagination.orderBy.field = 'indexName'
                break;
            default:
                break;
        }

    }

    const res = await request(
        'applications',
        'GET',
        null,
        true,
        {
            'x-pagination-num': pagination.page || 0,
            'x-pagination-limit': pagination.limit || 10,
            'x-pagination-sort': `${pagination?.orderBy?.field || 'createdAt'},${pagination?.orderBy?.order || 'desc'}`,
            'x-demo-mode': demoMode
        },
        filters
    )
    dispatch(dispatchApplicantsList(res.response, res.headers))
    return res
}

// get applicant detail by id
export const getApplicantsById = (applicantUUID) => async (dispatch) => {
    const res = await request(
        `applications/${applicantUUID}`,
        'GET'
    )
    dispatch(dispatchApplicantById(res))
    return res
}

export const getBrokersApplicantsById = (applicantUUID) => async (dispatch) => {
    const res = await request(
        `broker-portal/applications/${applicantUUID}`,
        'GET'
    )
    dispatch(dispatchApplicantById(res))
    return res
}

// archive application
export const archiveApplication = (applicantUUID, archived) => async () => {
    const res = await request(
        `applications/${applicantUUID}/archived`,
        'POST',
        { archived: archived }
    )
    return res
}

// get FMCSA data
// Endpoint called when opening Application Tab
export const getFmcsaData = (params, demoMode = false) => async (dispatch) => {
    const query = {
        ...params
    }
    const queryUrl = `?${queryString.stringify(query)}`
    const res = await request(
        'fmcsa/search',
        'GET',
        null,
        true,
        { 'x-demo-mode': demoMode },
        query
    )
    dispatch(dispatchFmcsaData(res.response.content, queryUrl, res.response.extraContent, res.response.uuid))
    return res
}

// get FMCSA data By DOT
export const getFmcsaDataByDOT = (params, demoMode = false) => async () => {
    const query = {
        ...params
    }
    const res = await request(
        'fmcsa/search',
        'GET',
        null,
        true,
        { 'x-demo-mode': demoMode },
        query
    )
    return res
}

export const requestFmcsaDataByApplication = (applicantId, demoMode= false) => async (dispatch) => {
    const res = await request('applications/'+applicantId+'/fmcsa/search', 'GET', null, false, { 'x-demo-mode': demoMode })
    dispatch(dispatchFmcsaData(res.content, null, res.extraContent, res.uuid))
    return res;
}

export const getFmcsaDataByApplication = (applicantId) => async (dispatch) => {
    const res = await request('applications/'+applicantId+'/fmcsa/data', 'GET')
    dispatch(dispatchFmcsaData(res.content, null, res.extraContent, res.uuid))
    return res;
}



// Prints the FMCSA report from the stored search (no new FMCSA request), including the latest extensive search
export const printFmcsaReport = (applicationId) => async () => {
    return await request(`applications/${applicationId}/fmcsa/report`, 'POST')
}

export const downloadFMCSAReport = (applicationId, dotNumber) => async () => {
    const res = await request(`applications/${applicationId}/fmcsa/search/report/${dotNumber}`, 'POST')
    return res
}

/**
 * Application create and update status API
 */
export const createApplication = (payLoad, isDemoMode=false) => async () => {
    const res = await request('applications', 'POST', payLoad, false, { 'x-demo-mode': isDemoMode })
    return res
}

export const updateApplicationStatus = (uuid, status, reasoning, isFraud, declineEmail) => async (dispatch) => {
    const res = await request(`applications/${uuid}/status`, 'PATCH', { status: status, reasoning: reasoning, fraud: isFraud, declineEmail })
    dispatch(dispatchApplicantById(res))
    return res
}

// Suggested recipients and reply-to addresses for the decline email (flag APPLICATION_DECLINE_EMAIL).
export const getDeclineEmailOptions = (uuid) => async () => {
    return await request(`applications/${uuid}/decline-email-options`, 'GET')
}

export const requestReports = (applicantId, params, isDemoMode=false) => async () => {
    return await request(`applications/${applicantId}/decision`, 'POST', null, true, { 'x-demo-mode': isDemoMode }, params)
}

/**
 * Owner creation and update API
 */
export const createOwner = (applicantId, payLoad) => async () => {
    const res = await request(`applications/${applicantId}/owners`, 'POST', payLoad)
    return res
}

export const updateOwner = (applicantId, payLoad) => async () => {
    delete payLoad?.createdBy
    delete payLoad?.updatedBy
    const res = await request(`applications/${applicantId}/owners/${payLoad?.uuid}`, 'PATCH', payLoad)
    return res
}

/**
 * Update Business API
 */
export const updateBusiness = (applicantId, payLoad) => async () => {
    const res = await request(`applications/${applicantId}/business`, 'PATCH', payLoad)
    return res
}

/**
 * Create and Update Debtor API
 */
export const updateDebtor = (applicantId, payLoad, type) => async () => {
    const res = await request(`applications/${applicantId}/debtors`, type, payLoad)
    return res
}

// Verfications API
export const getVerifications = applicantId => async (dispatch) => {
    const res = await request(`applications/${applicantId}/instantId`, 'GET')
    dispatch(dispatchVerificationList(res))
    return res
}

export const getVerificationData = (applicantId, payLoad, data,verificationStatusUuid) => async (dispatch) => {
    if (data)
        return dispatch(dispatchVerificationReport(data))

    if (verificationStatusUuid){
        const res = await request(`applications/${applicantId}/instantId/${verificationStatusUuid}`, 'GET')
        dispatch(dispatchVerificationReport(res))
        return res
    }

    const res = await request(`applications/${applicantId}/instantId`, 'POST', payLoad)
    dispatch(dispatchVerificationReport(res))
    return res
}

export const requestVerificationReportDemo = (applicantId, payLoad, data) => async (dispatch) => {
    if (data)
        return dispatch(dispatchVerificationReport(data))

    const res = await request(`applications/${applicantId}/instantId`, 'POST', payLoad, false, { 'x-demo-mode': true })
    dispatch(dispatchVerificationReport(res))
    return res
}

export const getVerificationRequestPreview = (applicantId) => async () => {
    return await request(`applications/${applicantId}/instantId/preview`, 'GET')
}

export const requestCustomVerification = (applicantId, payload) => async () => {
    return await request(`applications/${applicantId}/instantId/custom`, 'POST', payload)
}

export const saveVerificationReport = (applicantId, payLoad) => async () => {
    const res = await request(`applications/${applicantId}/instantId/save`, 'POST', payLoad)
    return res
}

export const attachVerificationReport = (applicantId, payLoad) => async () => {
    const res = await request(`applications/${applicantId}/verifications/attachReport`, 'POST', payLoad)
    return res
}

/**
 * Application Notes API
 */
export const createNotes = (applicantId, payLoad) => async () => {
    const res = await request(`applications/${applicantId}/notes`, 'POST', payLoad)
    return res
}

export const getNotes = (applicantId) => async (dispatch) => {
    const res = await request(`applications/${applicantId}/notes`, 'GET')
    dispatch(dispatchNotesList(res?.content))
    return res
}

export const brokerCreateNotes = (applicantId, payLoad) => async () => {
    const res = await request(`broker-portal/applications/${applicantId}/notes`, 'POST', payLoad)
    return res
}

export const brokerGetNotes = (applicantId) => async (dispatch) => {
    const res = await request(`broker-portal/applications/${applicantId}/notes`, 'GET')
    dispatch(dispatchNotesList(res?.content))
    return res
}

/**
 * Application Messages API
 */
export const sendMessage = (applicationUUID, message) => async (dispatch) => {
    const payLoad = {
        applicationUUID,
        message
    }
    const res = await request('applications/messages', 'POST', payLoad, false)
    dispatch(dispatchSendMessageSuccess(res))
    return res
}

export const getMessages = (applicationUUID) => async (dispatch) => {
    const res = await request(`applications/${applicationUUID}/messages`, 'GET', null, true)
    dispatch(dispatchMessagesList(res?.response || []))
    return res
}

export const getReputationReportStatus = async (applicantId) => {
  const res = await request(`applications/${applicantId}/reputation-report/status`, 'GET', null)
  return res
}

export const requestReputationReport = async (applicantId) => {
  const res = await request(`applications/${applicantId}/reputation-report`, 'POST', null)
  return res
}

export const getReputationReport = async (applicantId) => {
  const res = await request(`applications/${applicantId}/reputation-report`, 'GET')
  return res
}

export const getChameleonCarrier = async (applicationId, dotNumber) => {
  const res = await request(`applications/${applicationId}/dot/${dotNumber}/chameleon`, 'GET', null)
  return res
};

export const getCrashRisk = async (applicationId, dotNumber) => {
  const res = await request(`applications/${applicationId}/dot/${dotNumber}/crash-risk`, 'GET', null)
  return res
};

export const getInspectionTrend = async (applicationId, dotNumber) => {
  const res = await request(`applications/${applicationId}/dot/${dotNumber}/inspection-trend`, 'GET', null)
  return res
};

export const getReputationReportPhoto = async (applicantId, photoId) => {
  let status;
  return baseRequest(`applications/${applicantId}/reputation-report/photo/${photoId}`, 'POST', {})
    .then(res => {
      status = res.status;
      return res.blob();
    })
    .then(blob => {
      if (!blob.size) {
        throw new Error('Unexpected error when getting the image. Please retry. If the issue persists, please contact Support.');
      }
      if (status === 404) {
        throw new Error('Image not found');
      }
      return URL.createObjectURL(blob);
    })
    .catch(async err => {
      if (err.response) {
        try {
          if (err.response.status !== 404) {
            const parsedError = await err.response?.json();
            throw new Error(parsedError?.message || 'Failed to fetch image');
          } else {
            throw new Error('Image not found');
          }
        } catch (e) {
          throw new Error('Failed to fetch image');
        }
      }
      throw new Error(err.message || 'Failed to fetch image');
    });
}

/**
 * UCC API
 */
export const getUccList = (applicantId, reset) => async (dispatch) => {
    if (reset)
        dispatch(dispatchUCCInteractionList([]))

    const res = await request(`applications/${applicantId}/ucc/search`, 'GET')
    dispatch(dispatchUCCInteractionList(res))
    return res
}

export const getUccSearchTableData = async ({ applicationId }) => {
    return await request(`applications/${applicationId}/ucc/search`, 'GET')
}

//UCC search API for business / owner
export const uccSearch = (applicantId, payLoad, reset) => async (dispatch) => {
    if (reset){
        dispatch(dispatchUCCSearchId(null))
        return dispatch(dispatchUCCSearchData(null))
    }
    const demoMode = payLoad?.requestData?.isDemoMode ? payLoad.requestData.isDemoMode : false;
    const res = await request(`applications/${applicantId}/ucc/search`, 'POST', payLoad, false, { 'x-demo-mode': demoMode })
    dispatch(dispatchUCCSearchData(res?.response?.GroupedResults || []))
    dispatch(dispatchUCCSearchId(res?.uuid || []))
    dispatch(dispatchUCCSearchIndexDate(res?.response?.Header?.IndexDate || []))
    return res
}

export const performUccSearch = (applicantId, payLoad) => async () => {
    return await request(`applications/${applicantId}/ucc/search`, 'POST', payLoad)
}

export const performUccSearchDemoMode = (applicantId, payLoad) => async () => {
    return await request(`applications/${applicantId}/ucc/search`, 'POST', payLoad, false, { 'x-demo-mode': true })
}

export const dispatchUpdatedUccResponse = (data, dispatch) => {
    dispatch(dispatchUccResponse(data))
}

export const dispatchUccSearchParameters = (data, dispatch) => {
    dispatch(dispatchSearchParameters(data))
}

export const uccSearchHistory = (applicantId, query, pagination) => async () => {
    const res = await request(`applications/${applicantId}/ucc/search/history`,
    'GET',
    null,
    true,
    {
        'x-pagination-num': pagination.page || 0,
        'x-pagination-limit': pagination.limit || 5,
    },
    query)
    return res;
}

export const finishSearch = (applicantId, payload) => async () => {
    return await request(`applications/${applicantId}/ucc/search/finish`, 'POST', payload, false)
}

export const reopenSearch = (applicantId, payLoad) => async () => {
    return await request(`applications/${applicantId}/ucc/search/reopen`, 'POST', payLoad)
}

export const getUccData = (applicantId, payLoad) => async () => {
    return await request(`applications/${applicantId}/ucc/data`, 'POST', payLoad)
}

//UCC get detailed report for business / owner
export const getFilingDetails = (applicantId, payLoad, isDemoMode=false) => async () => {
    return await request(`applications/${applicantId}/ucc/filingDetails`, 'POST', payLoad, false, { 'x-demo-mode': isDemoMode })
}

export const attachNoResultsReport = ({applicationId, payload}) => async () => {
    const res = await request(`applications/${applicationId}/ucc/report/no-results`, 'POST', payload)
    return res
}

export const attachFilingDetailsReport = ({applicationId, interactionId}) => async () => {
    return await request(`applications/${applicationId}/ucc/report/filing-details/${interactionId}`, 'POST')
}

export const getTerminationPreview = (applicantId, filingDetailsId, filingNumber) => async dispatch => {
    const res = await request(`applications/${applicantId}/ucc/ucc-filings/${filingDetailsId}/${filingNumber}`, 'GET')
    dispatch(dispatchDebtors(res))
    return res
}

export const savefiling = (applicantId, payLoad, isDemoMode=false) => async () => {
    return await request(`applications/${applicantId}/ucc/saveFiling`, 'POST', payLoad, false, { 'x-demo-mode': isDemoMode })
}

export const attachFiling = ({applicationId, payload}) => async () => {
    return await request(`applications/${applicationId}/ucc/attachFiling`, 'POST', payload)
}

export const attachFilingDemoMode = ({applicationId, payload}) => async () => {
    return await request(`applications/${applicationId}/ucc/attachFiling`, 'POST', payload, false, { 'x-demo-mode': true })
}

export const getSavedDetail = (applicantId, type, id, skipDispatch) => async (dispatch) => {
    const res = await request(`applications/${applicantId}/ucc/search/savedData?type=${type}&uuid=${id}`, 'GET')
    if (!skipDispatch) dispatch(dispatchUCCSearchData(res, true))
    return res
}

export const getSavedDetailByApplication = (applicantId) => async () => {
    return await request(`applications/${applicantId}/ucc/search/savedData`, 'GET')
}

export const deleteReport = (applicantId, payLoad) => async () => {
    const res = await request(`applications/${applicantId}/ucc/search/delete`, 'DELETE', payLoad)
    return res
}

/**
 * Requests Documents from FCS
 */
export const retrieveDocument = (payLoad, state) => async () => {
    const { transactionID, filingNumbers, interactionId, offlineRequest, searchId } = payLoad || {}
    const requestPayload = {
        transactionID,
        filingNumbers,
        interactionId,
        offlineRequest,
        searchId,
        state
    }
    return await request(`ucc/documents/retrieve`, 'POST', requestPayload)
}

export const retrieveDocumentDemoMode = (payLoad, state) => async () => {
    const { transactionID, filingNumbers, interactionId, offlineRequest, searchId } = payLoad || {}
    const requestPayload = {
        transactionID,
        filingNumbers,
        interactionId,
        offlineRequest,
        searchId,
        state
    }
    return await request(`ucc/documents/retrieve`, 'POST', requestPayload, false, { 'x-demo-mode': true })
}

export const getRetrieveDocuments = (interactionId, reset) => async (dispatch) => {
    if (reset)
        return dispatch(dispatchRetrieveDocuments([]))

    const res = await request(`ucc/documents/retrieve/${interactionId}`, 'GET')
    dispatch(dispatchRetrieveDocuments(res))
    return res
}

/**
 * Endpoint get documents from DB without using dispatch
 */
export const getDocumentsFromDatabase = (interactionId) => async () => {
    return await request(`ucc/documents/retrieve/${interactionId}`, 'GET')
}
/**
 * Endpoint get Individual Filing Details
 */
export const getIndividualFilingDetails = (applicationId, interactionId) => async () => {
    return await request(`applications/${applicationId}/ucc/filingDetails/${interactionId}`, 'GET')
}

export const getDocumentStatus = (applicantId, interactionId, reset) => async (dispatch) => {
    if (reset)
        return dispatch(dispatchDocumentStatus([]))

    const res = await request(`applications/${applicantId}/interactionResponses/${interactionId}/ucc/documents`, 'GET')
    dispatch(dispatchDocumentStatus(res))
    return res
}

export const postFiling = (applicantId, payLoad, isDemoMode = false) => async () => {
    const res = await request(`applications/${applicantId}/ucc/postFiling`, 'POST', payLoad, false, { 'x-demo-mode': isDemoMode })
    return res
}

// UCC Credit list, search and report api
export const getCreditList = (applicantId) => async (dispatch) => {
    const query = {
        type: 'CREDIT',
        name: 'COM_SEARCH',
        byEntity: true,
        recordForNoData: true
    }
    const res = await request(
        `applications/${applicantId}/interactionResponses`,
        'GET',
        null,
        true,
        {},
        query
    )
    dispatch(dispatchCreditList(res?.response))
    return res
}

export const performCreditSearch = (applicantId) => async (dispatch) => {
    const res = await request(`applications/${applicantId}/creditcheck/companysearch`, 'POST');
    dispatch(dispatchCreditSearchResult(res))
    return res
}

export const getCompanyReport = (applicantId, companyId, reportId) => async (dispatch) => {
    let endPoint = `applications/${applicantId}/creditcheck/companyreport/${companyId}`
    if (reportId)
        endPoint = `applications/${applicantId}/interactionResponses/${reportId}`

    const res = await request(endPoint, 'GET')
    dispatch(dispatchCreditReportResult(res))
    return res
}

export const getSummaryReportByEntity = (applicantId, entityId, type) => async () => {
    if (type === 'LEXIS_BACKGROUND') {
        return await request(`applications/${applicantId}/backgroundVerification/entity`,
            'GET', null, true, {}, {entityId: entityId})
    }
    if (type === 'FMCSA') {
        return await request('applications/' + applicantId + '/fmcsa/data', 'GET', null)
    }
    if (type === 'LEXIS_VERIFICATION') {
        return await request(`applications/${applicantId}/verifications`, 'GET', null)
    }
}

export const saveReport = (applicantId, companyId) => async () => {
    const res = await request(`applications/${applicantId}/creditcheck/companyreport/${companyId}/save`, 'POST')
    return res
}

export const getBackgroundSearchSavedReport = (applicantId, backgroundSearchUuid) => async (dispatch) => {
    const res = await request(`applications/${applicantId}/background/${backgroundSearchUuid}`, 'GET')
    const verifiedInfo = res?.verifiedInfo
    let data;
    if (res?.entityType === 'OWNER'){
        data = res?.response?.BpsReportResponseEx?.response?.Individual || {}
        dispatch(dispatchBgvSearchResult(data))
    } else if (res?.productName === 'TOP_BIZ_SEARCH'){
        if (res?.pdfReportUuid) {
            data = res?.response?.TopBusinessReportResponseEx?.response?.Businesses?.Business[0] || {}
            dispatch(dispatchDetailedBusinessReport(data))
        } else {
            data = res?.response?.TopBusinessSearchResponseEx?.response?.Records?.Record || []
            if (verifiedInfo) data = checkVerifiedData(data, verifiedInfo)
            dispatch(dispatchBgvSearchResult(data))
        }
    }
    return res
}

export const getBgvList = (applicantId, reset) => async (dispatch) => {
    if (reset)
        return dispatch(dispatchBgvList([]))

    const res = await request(`applications/${applicantId}/background/search`, 'GET')
    dispatch(dispatchBgvList(res))
    return res
}

export const getConnectedBuisnessList = (applicantId, reset) => async (dispatch) => {
    if (reset)
        return dispatch(dispatchConnectedBuisnessList([]))

    const res = await request(`applications/${applicantId}/background/connectedBusiness`, 'GET')
    dispatch(dispatchConnectedBuisnessList(res))
    return res
}

export const performBgvSearch = (applicantId, payLoad, isDemoMode = false) => async (dispatch) => {
    const res = await request(`applications/${applicantId}/backgroundVerification/search`, 'POST', payLoad, false, { 'x-demo-mode': isDemoMode})
    const isBusiness = Object.keys(payLoad)[0] === 'businessId'
    const verifiedInfo = res?.verifiedInfo
    let data;
    if (isBusiness) {
        if (res?.pdfReportUuid) {
            data = res?.response?.TopBusinessReportResponseEx?.response?.Businesses?.Business[0] || {}
            dispatch(dispatchDetailedBusinessReport(data))
        } else {
            data = res?.response?.TopBusinessSearchResponseEx?.response?.Records?.Record || []
            if (verifiedInfo) data = checkVerifiedData(data, verifiedInfo)
            dispatch(dispatchBgvSearchResult(data))
        }
    } else {
        data = res?.response?.BpsReportResponseEx?.response?.Individual || {}
        dispatch(dispatchBgvSearchResult(data))
    }    
    return res
}

const checkVerifiedData = (data, verifiedInfo) => {
    data.forEach(item => {
        const businessIds = item?.BusinessIds
        const isVerified = Object.entries(businessIds).every(([key, value]) => verifiedInfo[key] === value)
        if (isVerified) {
            item.verified = true
        }
    })
    return data
}

export const performBgvSearchSummary = (applicantId, payLoad, isDemoMode) => async () => {
    const res = await request(`applications/${applicantId}/background/summary/business`, 'GET')
    return res
}

export const saveBgvReport = (applicantId, payLoad) => async () => {
    const res = await request(`applications/${applicantId}/backgroundVerification/save`, 'POST', payLoad)
    return res
}
export const saveBgvReportDemoMode = (applicantId, payLoad) => async () => {
    const res = await request(`applications/${applicantId}/backgroundVerification/save`, 'POST', payLoad, false, { 'x-demo-mode': true })
    return res
}

export const getDetailedBusinessReport = (applicantId, payLoad, isDemoMode = false) => async (dispatch) => {
    const res = await request(`applications/${applicantId}/backgroundVerification/getReport`, 'POST', payLoad, false, { 'x-demo-mode': isDemoMode})
    dispatch(dispatchDetailedBusinessReport(res?.response?.TopBusinessReportResponseEx?.response?.Businesses?.Business[0] || {}))
    return res
}

export const saveBuisnessReport = (applicantId, payLoad) => async () => {
    const res = await request(`applications/${applicantId}/backgroundVerification/save`, 'POST', payLoad)
    return res
}
export const saveBusinessReportDemoMode = (applicantId, payLoad) => async () => {
    const res = await request(`applications/${applicantId}/backgroundVerification/save`, 'POST', payLoad, false, { 'x-demo-mode': true })
    return res
}

export const attachFile = (applicantId, payLoad) => async () => {
    const res = await request(`applications/${applicantId}/backgroundVerification/attachReport`, 'POST', payLoad)
    return res
}

export const getConnectedBuisnessReport = (applicantId, payLoad, reset, isDemoMode = false) => async (dispatch) => {
    if (reset)
        return dispatch(dispatchConnectedBusinessReport(true))

    const res = await request(`applications/${applicantId}/backgroundVerification/connectedBusinessReport/get`, 'POST', payLoad, false, { 'x-demo-mode': isDemoMode })
    let data
    if (res?.response?.TopBusinessReportResponseEx?.response?.Businesses?.Business[0]) {
        data = res.response.TopBusinessReportResponseEx.response.Businesses.Business[0]
        data.key = String(payLoad.BusinessIds.OrgID)
    }

    dispatch(dispatchConnectedBusinessReport(data || {}))
    return res
}

export const saveConnectedBuisnessReport = (applicantId, payLoad, isDemoMode = false) => async () => {
    const res = await request(`applications/${applicantId}/backgroundVerification/connectedBusinessReport/save`, 'POST', payLoad, false, { 'x-demo-mode': isDemoMode })
    return res
}

// UCC1 filing API's
export const getUccFilingList = (applicantId, reset) => async (dispatch) => {
    if (reset)
        dispatch(dispatchFilingList([]))

    const res = await request(`applications/${applicantId}/ucc/ucc-filings`, 'GET')
    dispatch(dispatchFilingList(res))
    return res
}

export const getUccFilingsForApplication = async ({ applicationId }) => {
    return await request(`applications/${applicationId}/ucc/ucc-filings`, 'GET')
}

export const getJurisdictionList = (params) => async () => {
    const res = await request(
        'jurisdiction',
        'GET',
        null,
        true,
        {},
        params
    )

    const response = res?.response;
    // find index of Secretary of State option
    const indexSOS = response.findIndex(option => option.name === 'Secretary of State');
    // if an index was found we move it at the first position
    if (indexSOS !== -1) {
        const sos = response.splice(indexSOS, 1);
        response.unshift(sos[0]);
    }
    return response
}

export const getJurisdictionsSiblings = (jurisdictionId) => async () => {
    const res = await request(
        `jurisdiction/${jurisdictionId}/siblings`, 'GET')
    return res
}

export const getdirectAmendmentsList = applicationId => async dispatch => {
    const res = await request(`applications/${applicationId}/ucc/ucc-filings/direct-amendments`, "GET")
    dispatch(dispatchDirectAmendmentList(res))
    return res
}

export const getTemplates = () => async (dispatch) => {
    const res = await request(`templates`, "GET")
    dispatch(dispatchTemplateList(res))
    return res
}

export const filingPreview = (applicantId, payLoad, details) => async (dispatch) => {
    const res = await request(`applications/${applicantId}/ucc/postFiling/preview`, "POST", payLoad)
    dispatch(dispatchUCCPreview({ ...res, ...details }))
    return res
}

// attachments upload,get,delete and download API
export const uploadFile = (applicantId, payLoad) => async () => {
    const res = await request(
        `applications/${applicantId}/files`,
        'POST',
        payLoad,
        true,
        { 'Content-Type': 'multipart/form-data' }
    )
    return res
}

export const uploadRoxFiles = (payLoad) => async () => {
    const res = await request(
        `files`,
        'POST',
        payLoad,
        true,
        { 'Content-Type': 'multipart/form-data' }
    )
    return res
}

export const getFilingReportsAttachments = (applicationUuid, pagination = {}, query = {}) => async (dispatch) => {
    const res = await request(
        `applications/${applicationUuid}/ucc/search/files`,
        'GET',
        null,
        true,
        {
            'x-pagination-num': pagination.page || 0,
            'x-pagination-limit': pagination.limit || 10
        },
        query
    )
    dispatch(dispatchAttachmentList(res.response, res.headers))
    return res
}

export const getBankDataRequests = (applicantId) => async ()=> {
    return await request(
        `applications/${applicantId}/bank-transactions/status`,
        'GET',
        null
    )
}

export const sendEmailToOwnerDueCurrentStatus = (applicantId, ownerId, demoMode = false) => async () => {
    return await request(
        `applications/${applicantId}/owners/${ownerId}/bank-transactions/send-email`,
        'POST', null, false, {'x-demo-mode': demoMode}
    )
}

export const getFiles = (applicantId, pagination = {}, query = {}) => async (dispatch) => {
    const res = await request(
        `applications/${applicantId}/files`,
        'GET',
        null,
        true,
        {
            'x-pagination-num': pagination.page || 0,
            'x-pagination-limit': pagination.limit || 10
        },
        query
    )
    dispatch(dispatchAttachmentList(res.response, res.headers))
    return res
}

export const getMemoStatus = (roxAppId) => async (dispatch) => {
    const res = await request(
        `openai/memo/${roxAppId}/status`,
        'GET'
    );
    dispatch(dispatchMemoStatus(res.status));
    return res;
};

export const deleteFile = (applicantId, fileId) => async () => {
    const res = await request(`applications/${applicantId}/files/${fileId}`, 'DELETE')
    return res
}

export const downLoadAttachment = (applicantId, fileId, fileName) => async () => {
    if (applicantId){
        return  await downloadFile(`applications/${applicantId}/files/${fileId}/download`, 'GET', null, fileName)
    }
    return await downloadFile(`files/${fileId}/download`, 'GET', null, fileName)
}

export const downloadAttachedFiles = (body, zipName) => async () => {

    const res = await downloadFile('files/download', 'POST', body, zipName)

    return res
}

export const getAttachmentPDF = (payload) => async () => {
    // applicationId is the correct key; applicantionId stays for existing callers
    const applicationId = payload?.applicationId ?? payload?.applicantionId
    if (applicationId){
        return await getPDF(`applications/${applicationId}/files/${payload.fileId}/download`)
    }
    return await getPDF(`files/${payload.fileId}/download`)
}

export const getAttachmentImage = (payload) => async () => {
    if (payload?.applicationId) {
        return await getImage(`applications/${payload.applicationId}/files/${payload.fileId}/download`);
    }
    return await getImage(`files/${payload.fileId}/download`);
};


export const downLoadAttachmentByFileId = (fileId, fileName) => async () => {
    return await downloadFile(`files/${fileId}/download`, 'GET', null, fileName)
}

//Endpoint receives payload with file id, file name and optional application id
export const downloadFileByPayload = (payload) => async () => {
    // applicationId is the correct key; applicantionId stays for existing callers
    const applicationId = payload?.applicationId ?? payload?.applicantionId
    if (applicationId){
        return  await downloadFile(`applications/${applicationId}/files/${payload.fileId}/download`, 'GET', null, payload.fileName)

    }
    return await downloadFile(`files/${payload.fileId}/download`, 'GET', null, payload.fileName)
}

export const requestUCCForceUpdate = (filingId, demoMode = false) => async (dispatch) => {
    const res = await request(`ucc/ucc-filings/${filingId}/update-status`, 'POST', null, false, { 'x-demo-mode': demoMode })
    dispatch(dispatchUCCPreview(res))
    return res
}

export const getUccFilingDetailsByEntity = (applicationId, entityUuid, reset, query) => async (dispatch) => {
    if (reset)
        return dispatch(dispatchUCCPreview({}))
    const res = await request(`applications/${applicationId}/ucc/ucc-filings/${entityUuid}`, 'GET', null, false, {}, query)
    dispatch(dispatchUCCPreview(res))
    return res
}

//This endpoint is called when opening ucc from UCCs Tab
export const getUccFilingDetailsByFilingNumber = (filingNumber, type, isDemoMode=false) => async (dispatch) => {
    const res = await request(`ucc/ucc-filings/${filingNumber}`, 'GET', null, false, { 'x-demo-mode': isDemoMode })
    if (type === 'amendment')
        dispatch(dispatchAmendmentPreview(res))
    else if (type === 'ucc1')
        dispatch(dispatchUCCPreview(res))
    else
        dispatch(dispatchUCC3Preview(res))
    return res
}

export const requestUccFilingImage = (filingId, demoMode = false) => async () => {
    return  await request(`ucc/${filingId}/generate-image`, 'POST', null, false, { 'x-demo-mode': demoMode })
}
export const getUccFilingDetailsByFilingId = (filingId, type) => async (dispatch) => {
    const res = await request(`ucc/ucc-filings/filing-id/${filingId}`, 'GET')
    if (type === 'amendment')
        dispatch(dispatchAmendmentPreview(res))
    else if (type === 'ucc1')
        dispatch(dispatchUCCPreview(res))
    else
        dispatch(dispatchUCC3Preview(res))
    return res
}

export const continueUCC = payLoad => async () => {
    const res = await request(`ucc/continuation`, 'POST', payLoad, false, { 'x-demo-mode': payLoad?.isDemoMode })
    return res
}

export const terminateUCC = payLoad => async () => {
    return await request(`ucc/termination`, 'POST', payLoad, false, { 'x-demo-mode': payLoad?.isDemoMode })
}

export const getActiveList = (pagination = {}, filters = {}, isDemoMode=false) => async (dispatch) => {
    if (pagination?.orderBy?.field) {
        switch (pagination?.orderBy?.field) {
            case 'filingNumber':
                pagination.orderBy.field = 'fileNumber'
                break;
            case 'creationDate':
                pagination.orderBy.field = 'createdAt'
                break;
            case 'debtorName':
                pagination.orderBy.field = 'indexName'
                break;
            case 'lapseDate':
                pagination.orderBy.field = 'currentLapseDate'
                break;
            default:
                break;
        }

    }
    const res = await request(
        `ucc/ucc-filings`,
        'GET',
        null,
        true,
        {
            'x-pagination-num': pagination.page || 0,
            'x-pagination-limit': pagination.limit || 10,
            'x-pagination-sort': `${pagination?.orderBy?.field || 'createdAt'},${pagination?.orderBy?.order || 'desc'}`,
            'x-demo-mode': isDemoMode
        },
        filters
    )
    dispatch(dispatchActiveList(res.response, res.headers))
    return res
}

export const getDebtors = (filingNumber, isDemoMode = false) => async (dispatch) => {
    const res = await request(`ucc/ucc-filings/${filingNumber}`, 'GET', null, false, { 'x-demo-mode': isDemoMode })
    dispatch(dispatchDebtors(res))
    return res
}

export const performAmendmentOperation = payLoad => async () => {
    const res = await request(`ucc/party-amendment`, 'POST', payLoad, false, { 'x-demo-mode': payLoad?.isDemoMode })
    return res
}

export const performCollateralOperation = payLoad => async () => {
    const res = await request(`ucc/collateral-amendment`, 'POST', payLoad, false, { 'x-demo-mode': payLoad?.isDemoMode })
    return res
}

export const uploadTempFile = (applicantId, payLoad) => async () => {
    const res = await request(
        `ucc/ucc-filings/submit-temp-file`,
        'POST',
        payLoad,
        true,
        { 'Content-Type': 'multipart/form-data' }
    )
    return res
}

export const getTempFiles = (pagination = {}) => async (dispatch) => {
    const res = await request(
        `ucc/temp-attachments`,
        'GET',
        null,
        true,
        {
            'x-pagination-num': pagination.page || 0,
            'x-pagination-limit': pagination.limit || 10
        }
    )
    dispatch(dispatchTempFilesList(res.response, res.headers))
    return res
}

export const requestBankDataAccess = (applicantId, ownerId, demoMode = false) => async () => {
    const res = await request(`applications/${applicantId}/owners/${ownerId}/requestBankDataAccess`, 'POST', null, false, { 'x-demo-mode': demoMode })
    return res
}

//TODO: In the future, we need to request accounts
export const requestAccounts = (applicantId, ownerId) => async () => {
    const res = await request(`applications/${applicantId}/owners/${ownerId}/accounts/request`, 'POST')
    return res
}

export const getListOfAccounts = (applicantId, ownerId, pagination = {}) => async () => {
    const res = await request(`applications/${applicantId}/owners/${ownerId}/accounts`,
        'GET',
        null,
        true,
        {
            'x-pagination-num': pagination.page || 0,
            'x-pagination-limit': pagination.limit || 10,
            'x-pagination-sort': `${pagination?.orderBy?.field || 'createdAt'},${pagination?.orderBy?.order || 'desc'}`
        }
    )
    return res
}

export const requestBankTransactions = (applicantID, ownerId, payLoad, demoMode = false) => async () => {
    const res = await request(`applications/${applicantID}/owners/${ownerId}/transactions/request`,
        'POST', payLoad, false, { 'x-demo-mode': demoMode })
    return res
}

export const getListOfBankTransactions = (applicantId, ownerId, params, pagination = {}) => async (dispatch) => {
    const res = await request(
        `applications/${applicantId}/owners/${ownerId}/transactions`,
        'GET',
        null,
        true,
        {
            'x-pagination-num': pagination.page || 0,
            'x-pagination-limit': pagination.limit || 5,
            'x-pagination-sort': `${pagination?.orderBy?.field || 'date'},${pagination?.orderBy?.order || 'asc'}`
        },
        params
    )
    dispatch(dispatchListOfBankTransactions(res.response, res.headers))
    return res
}

export const getListOfFilteredBankTransactions = (applicantId, ownerId, params, pagination = {}) => async (dispatch) => {
    const res = await request(`applications/${applicantId}/owners/${ownerId}/transactions`,
        'GET',
        null,
        true,
        {
            'x-pagination-num': pagination.page || 0,
            'x-pagination-limit': pagination.limit || 5,
            'x-pagination-sort': `${pagination?.orderBy?.field || 'date'},${pagination?.orderBy?.order || 'asc'}`        },
        params
    )
    return res
}

export const requestRecurrentBankTransactions = (applicantId, ownerId, payLoad, demoMode = false) => async () => {
    const res = await request(`applications/${applicantId}/owners/${ownerId}/recurrentTransactions/request`,
        'POST', payLoad, false, { 'x-demo-mode': demoMode })
    return res
}
export const getListOfRecurrentBankTransactions = (applicantId, ownerId, params, pagination = {}) => async (dispatch) => {
    const res = await request(`applications/${applicantId}/owners/${ownerId}/recurrentTransactions`,
        'GET',
        null,
        true,
        {
            'x-pagination-num': pagination.page || 0,
            'x-pagination-limit': pagination.limit || 5,
            'x-pagination-sort': `${pagination?.orderBy?.field || 'lastDate'},${pagination?.orderBy?.order || 'desc'}`
        },
        params
    )
    dispatch(dispatchListOfRecurrentBankTransactions(res.response, res.headers))
    return res
}

export const getRecurrentTransactionData = (applicantId, ownerId, transactionId) => async () => {
    const res = await request(`applications/${applicantId}/owners/${ownerId}/bank-transactions/recurrent-transactions/${transactionId}`, 'GET')
    return res
}

export const getAssetsReportData = (applicantId) => async (dispatch) => {
    const res = await request(`applications/${applicantId}/assets-report`, 'GET')
    if (res) {
        dispatch(dispatchAssetsReportData(res))
    }
    return res
}

export const getAssetsReportTransactions = (applicantId, params = {}, pagination = {}) => async (dispatch) => {
    const headers = {
        'x-pagination-num': pagination.page || 0,
        'x-pagination-limit': pagination.limit || 10,
        'x-pagination-sort': `${pagination?.orderBy?.field || 'date'},${pagination?.orderBy?.order || 'desc'}`
    }
    
    const res = await request(`applications/${applicantId}/assets-report/transactions`, 'GET', null, true, headers, params)
    if (res) {
        dispatch(dispatchAssetsReportTransactions(res.response, res.headers))
    }
    return res
}

export const getDataForTransactionsCharts = (applicantId, ownerId, accountId, params) => async () => {
    const res = await request(
        `applications/${applicantId}/owners/${ownerId}/bank-transactions/accounts/${accountId}/charts`,
        'GET',
        null,
        false,
        {},
        params,
    )
    return res
}

export const getDataForInsights = (applicantId, ownerId, accountId) => async () => {
    const res = await request(
        `applications/${applicantId}/owners/${ownerId}/bank-transactions/accounts/${accountId}/insights`,
        'GET',
    )
    return res
}

export const getBusinessReportSummary = (applicantionId, reportType, isDemoMode=false) => async () => {
    const res = await request(`applications/${applicantionId}/summary?reportType=${reportType}`, 'GET', null, false, { 'x-demo-mode': isDemoMode })
    return res
}

export const getOwnerReportSummary = (applicantionId, ownerId, reportType) => async () => {
    const res = await request(`applications/${applicantionId}/summary/owners/${ownerId}?reportType=${reportType}`, 'GET')
    return res
}

export const getSummaryInfo = (applicantionId) => async () => {
    const res = await request(`application/${applicantionId}/decision/summary`, 'GET')
    return res
}

export const getAvailableSummary = (applicantionId) => async () => {
    const res = await request(`applications/${applicantionId}/availableSummary`, 'GET')
    return res
}

export const getSingleAvailableSummary = (applicantionId, params) => async () => {
    const res = await request(`applications/${applicantionId}/availableSummary`, 'GET', null, false, {}, params)
    return res
}

export const requestApplicationInfo = (applicantionId) => async () => {
    const res = await request(`applications/${applicantionId}/info`, 'GET')
    return res
}

//SOS

// get sos searches by application id
export const getSosSearches = ({applicantId, pagination = {}}) => async () => {
    const res = await request(
        `applications/${applicantId}/sos/search`,
        'GET',
        null,
        true,
        {
            'x-pagination-num': pagination.page || 0,
            'x-pagination-limit': pagination.limit || 5
        }
    )
    return res
}

// perform sos search
export const requestSosSearch = ({ applicationId, payload }) => async () => {
    const res = await request(`applications/${applicationId}/sos/search`, 'POST', payload)
    return res
}
export const requestSosSearchDemoMode = ({ applicationId, payload }) => async () => {
    const res = await request(`applications/${applicationId}/sos/search`, 'POST', payload, false, {"x-demo-mode": true})
    return res
}

// get an specific sos search
export const getSosSearch = ({ applicantId, searchId }) => async () => {
    const res = await request(`applications/${applicantId}/sos/search/${searchId}`, 'GET')
    return res
}

// get sos search by autoreport
export const getSosSearchAutoreport = (applicantId, demoMode=false) => async () => {
    const res = await request(`applications/${applicantId}/sos/search/autoreport`, 'GET', null, false, { 'x-demo-mode': demoMode })
    return res
}

// get sos saved records by application id
export const getSosSavedRecords = (applicantionId, pagination = {}) => async () => {
    const res = await request(
        `applications/${applicantionId}/sos/records`,
        'GET',
        null,
        true,
        {
            'x-pagination-num': pagination.page || 0,
            'x-pagination-limit': pagination.limit || 5
        }
    )
    return res
}

// get an specific sos saved record
export const getSavedRecord = (applicantionId, recordId) => async () => {
    const res = await request(`applications/${applicantionId}/sos/record/${recordId}`, 'GET')
    return res
}

// save sos record 
export const saveSosRecord = ({applicationId, payload}) => async () => {
    const res = await request(`applications/${applicationId}/sos/save`, 'POST', payload)
    return res
}

//SOS Quick Search

// perform sos quick search
export const sosQuickSearch = ({payload}) => async () => {
    const res = await request(`quicksearch/sos/search`, 'POST', payload)
    return res
}
export const sosQuickSearchDemoMode = ({payload}) => async () => {
    const res = await request(`quicksearch/sos/search`, 'POST', payload, false, {"x-demo-mode": true})
    return res
}

// get searches by client
export const getSosQuickSearches = ({pagination = {}, demoMode = false}) => async () => {
    const res = await request(
        `quicksearch/sos/search`,
        'GET',
        null,
        true,
        {
            'x-pagination-num': pagination.page || 0,
            'x-pagination-limit': pagination.limit || 5,
            'x-demo-mode': demoMode
        }
    )
    return res
}

// get saved records by client
export const getSosSavedRecordsQS = (pagination = {}) => async () => {
    const res = await request(
        `quicksearch/sos/records`,
        'GET',
        null,
        true,
        {
            'x-pagination-num': pagination.page || 0,
            'x-pagination-limit': pagination.limit || 5
        }
    )
    return res
}

// get sos search by id
export const getSosQuickSearch = ({searchId}) => async () => {
    const res = await request(`quicksearch/sos/search/${searchId}`, 'GET')
    return res
}

// get saved record by id
export const getSavedRecordQS = (recordId) => async () => {
    const res = await request(`quicksearch/sos/record/${recordId}`, 'GET')
    return res
}

// save sos record from quick search
export const saveSosRecordQS = (payload) => async () => {
    const res = await request(`quicksearch/sos/save`, 'POST', payload)
    return res
}

export const requestAllStatesSearch = ({ applicationId, payload }) => async () => {
    const res = await request(`applications/${applicationId}/sos/all-states-search`, 'POST', payload)
    return res
}

//SAM.gov Quick Search

export const samgovQuickSearch = ({ payload }) => async () => {
    const res = await request(`quicksearch/samgov/search`, 'POST', payload)
    return res
}

export const samgovQuickSearchDemoMode = ({ payload }) => async () => {
    const res = await request(`quicksearch/samgov/search`, 'POST', payload, false, { 'x-demo-mode': true })
    return res
}

export const getSamgovQuickSearch = ({ searchId }) => async () => {
    const res = await request(`quicksearch/samgov/search/${searchId}`, 'GET')
    return res
}

export const getSamgovQuickSearches = ({ pagination = {}, demoMode = false }) => async () => {
    const res = await request(
        `quicksearch/samgov/search`,
        'GET',
        null,
        true,
        {
            'x-pagination-num': pagination.page || 0,
            'x-pagination-limit': pagination.limit || 5,
            'x-demo-mode': demoMode
        }
    )
    return res
}

export const getSamgovRequestCount = () => async () => {
    const res = await request(`admin/samgov/request-count`, 'GET')
    return res
}

export const adminSearchInteractionResponses = ({ params, pageLimit = 20, pageNumber = 0, sort = 'createdAt,desc' }) => async () => {
    const headers = {
        'x-pagination-limit': String(pageLimit),
        'x-pagination-num': String(pageNumber),
        'x-pagination-sort': sort,
    }
    const clean = Object.fromEntries(Object.entries(params || {}).filter(([, v]) => v !== '' && v != null))
    const res = await request(`admin/interactionResponses`, 'GET', undefined, true, headers, clean)
    return res
}

export const adminGetInteractionFilters = () => request(`admin/interactionResponses/filters`, 'GET')

export const adminGetInteractionResponse = ({ interactionResponseId }) => async () => {
    const res = await request(`admin/interactionResponses/${interactionResponseId}`, 'GET')
    return res
}

export const adminSearchReceivedHooks = ({ params, pageLimit = 20, pageNumber = 0, sort = 'createdAt,desc' }) => async () => {
    const headers = {
        'x-pagination-limit': String(pageLimit),
        'x-pagination-num': String(pageNumber),
        'x-pagination-sort': sort,
    }
    const clean = Object.fromEntries(Object.entries(params || {}).filter(([, v]) => v !== '' && v != null))
    const res = await request(`admin/received-hooks`, 'GET', undefined, true, headers, clean)
    return res
}

export const adminGetReceivedHook = ({ uuid }) => async () => {
    const res = await request(`admin/received-hooks/${uuid}`, 'GET')
    return res
}

export const getSamgovIngestStatus = () => async () => {
    const res = await request(`admin/samgov/ingest-status`, 'GET')
    return res
}

export const triggerSamgovIngest = () => async () => {
    const res = await request(`admin/samgov/ingest-run`, 'POST')
    return res
}

export const saveSamgovRecord = ({ applicationId, payload }) => async () => {
    const res = await request(`applications/${applicationId}/samgov/save`, 'POST', payload)
    return res
}

export const getNppesIngestStatus = () => async () => {
    const res = await request(`admin/nppes/ingest-status`, 'GET')
    return res
}

export const triggerNppesIngest = ({ force = false } = {}) => async () => {
    const res = await request(`admin/nppes/ingest-run`, 'POST', undefined, false, undefined, { force })
    return res
}

export const triggerNppesIngestFromFile = ({ path }) => async () => {
    const res = await request(`admin/nppes/ingest-run-from-file`, 'POST', undefined, false, undefined, { path })
    return res
}

export const getSamgovSavedRecords = ({ applicationId }) => async () => {
    const res = await request(`applications/${applicationId}/samgov/records`, 'GET')
    return res
}

export const deleteSamgovSavedRecord = ({ applicationId, recordId }) => async () => {
    const res = await request(`applications/${applicationId}/samgov/records/${recordId}`, 'DELETE')
    return res
}

//NPPES (NPI Registry) Quick Search

export const nppesQuickSearch = ({ payload }) => async () => {
    const res = await request(`quicksearch/nppes/search`, 'POST', payload)
    return res
}

export const nppesQuickSearchDemoMode = ({ payload }) => async () => {
    const res = await request(`quicksearch/nppes/search`, 'POST', payload, false, { 'x-demo-mode': true })
    return res
}

export const getNppesQuickSearch = ({ searchId }) => async () => {
    const res = await request(`quicksearch/nppes/search/${searchId}`, 'GET')
    return res
}

export const getNppesQuickSearches = ({ pagination = {}, demoMode = false }) => async () => {
    const res = await request(
        `quicksearch/nppes/search`,
        'GET',
        null,
        true,
        {
            'x-pagination-num': pagination.page || 0,
            'x-pagination-limit': pagination.limit || 5,
            'x-demo-mode': demoMode
        }
    )
    return res
}

export const saveNppesRecord = ({ applicationId, payload }) => async () => {
    const res = await request(`applications/${applicationId}/nppes/save`, 'POST', payload)
    return res
}

export const getNppesSavedRecords = ({ applicationId }) => async () => {
    const res = await request(`applications/${applicationId}/nppes/records`, 'GET')
    return res
}

export const deleteNppesSavedRecord = ({ applicationId, recordId }) => async () => {
    const res = await request(`applications/${applicationId}/nppes/records/${recordId}`, 'DELETE')
    return res
}

// LEIE (HHS OIG Exclusions) admin

export const getLeieIngestStatus = () => async () => {
    const res = await request(`admin/leie/ingest-status`, 'GET')
    return res
}

export const triggerLeieIngest = ({ force = false } = {}) => async () => {
    const res = await request(`admin/leie/ingest-run`, 'POST', undefined, false, undefined, { force })
    return res
}

// OFAC (Treasury SDN sanctions) admin

export const getOfacIngestStatus = () => async () => {
    const res = await request(`admin/ofac/ingest-status`, 'GET')
    return res
}

export const triggerOfacIngest = ({ force = false } = {}) => async () => {
    const res = await request(`admin/ofac/ingest-run`, 'POST', undefined, false, undefined, { force })
    return res
}

// State Medicaid (multi-state) admin

export const getStateMedicaidIngestStatus = () => async () => {
    const res = await request(`admin/state-medicaid/ingest-status`, 'GET')
    return res
}

/**
 * Trigger a state Medicaid ingest.
 *  - Omit `state` to run every registered state (force must be false — force+all is not supported)
 *  - Pass `state: 'CA'` to run one state
 *  - `force: true` re-downloads even when Last-Modified is unchanged (per-state only)
 */
export const triggerStateMedicaidIngest = ({ state, force = false } = {}) => async () => {
    const params = {}
    if (state) params.state = state
    if (force) params.force = true
    const res = await request(`admin/state-medicaid/ingest-run`, 'POST', undefined, false, undefined, params)
    return res
}

/**
 * Non-admin coverage endpoint. Returns `{ stateCodes: [...] }`. Safe to call from any authenticated
 * user; used by the Quick Search tab to populate the state-filter dropdown and coverage badge.
 * (Do NOT use the admin ingest-status endpoint from user-facing code — it 401s non-admins and the
 * JWT interceptor treats that as an expired session and auto-logs the user out.)
 */
export const getStateMedicaidCoverage = () => async () => {
    const res = await request(`quicksearch/state-medicaid/coverage`, 'GET')
    return res
}

// Upload-CSV admin endpoints — for local testing against a specific file without hitting the
// upstream feed (no API quota burn on SAM.gov, no 1.1 GB CMS pull on NPPES, etc.). Each ds's
// backend endpoint accepts a multipart file and returns the RUNNING ingest_run immediately.

const uploadCsv = async (path, file, extraParams) => {
    const body = new FormData()
    body.append('file', file)
    // `request` recognises the multipart Content-Type header and passes the FormData through untouched.
    return request(
        path,
        'POST',
        body,
        false,
        { 'Content-Type': 'multipart/form-data' },
        extraParams
    )
}

export const uploadLeieIngest = ({ file }) => async () => uploadCsv(`admin/leie/ingest-upload`, file)
export const uploadNppesIngest = ({ file }) => async () => uploadCsv(`admin/nppes/ingest-upload`, file)
export const uploadSamgovIngest = ({ file }) => async () => uploadCsv(`admin/samgov/ingest-upload`, file)
// OFAC is three files ingested together, so it posts them as separate multipart parts (sdn / alt / add).
export const uploadOfacIngest = ({ sdn, alt, add }) => async () => {
    const body = new FormData()
    body.append('sdn', sdn)
    body.append('alt', alt)
    body.append('add', add)
    return request(`admin/ofac/ingest-upload`, 'POST', body, false, { 'Content-Type': 'multipart/form-data' })
}
export const uploadStateMedicaidIngest = ({ state, file }) => async () =>
    uploadCsv(`admin/state-medicaid/ingest-upload`, file, { state })

// LEIE (HHS OIG Exclusions) Quick Search

export const leieQuickSearch = ({ payload }) => async () => {
    const res = await request(`quicksearch/leie/search`, 'POST', payload)
    return res
}

export const leieQuickSearchDemoMode = ({ payload }) => async () => {
    const res = await request(`quicksearch/leie/search`, 'POST', payload, false, { 'x-demo-mode': true })
    return res
}

export const getLeieQuickSearch = ({ searchId }) => async () => {
    const res = await request(`quicksearch/leie/search/${searchId}`, 'GET')
    return res
}

export const getLeieQuickSearches = ({ pagination = {}, demoMode = false }) => async () => {
    const res = await request(
        `quicksearch/leie/search`,
        'GET',
        null,
        true,
        {
            'x-pagination-num': pagination.page || 0,
            'x-pagination-limit': pagination.limit || 5,
            'x-demo-mode': demoMode
        }
    )
    return res
}

export const saveLeieRecord = ({ applicationId, payload }) => async () => {
    const res = await request(`applications/${applicationId}/leie/save`, 'POST', payload)
    return res
}

export const getLeieSavedRecords = ({ applicationId }) => async () => {
    const res = await request(`applications/${applicationId}/leie/records`, 'GET')
    return res
}

export const deleteLeieSavedRecord = ({ applicationId, recordId }) => async () => {
    const res = await request(`applications/${applicationId}/leie/records/${recordId}`, 'DELETE')
    return res
}

// State Medicaid Exclusions Quick Search

export const stateMedicaidQuickSearch = ({ payload }) => async () => {
    const res = await request(`quicksearch/state-medicaid/search`, 'POST', payload)
    return res
}

export const stateMedicaidQuickSearchDemoMode = ({ payload }) => async () => {
    const res = await request(`quicksearch/state-medicaid/search`, 'POST', payload, false, { 'x-demo-mode': true })
    return res
}

export const getStateMedicaidQuickSearch = ({ searchId }) => async () => {
    const res = await request(`quicksearch/state-medicaid/search/${searchId}`, 'GET')
    return res
}

export const getStateMedicaidQuickSearches = ({ pagination = {}, demoMode = false }) => async () => {
    const res = await request(
        `quicksearch/state-medicaid/search`,
        'GET',
        null,
        true,
        {
            'x-pagination-num': pagination.page || 0,
            'x-pagination-limit': pagination.limit || 5,
            'x-demo-mode': demoMode
        }
    )
    return res
}

export const saveStateMedicaidRecord = ({ applicationId, payload }) => async () => {
    const res = await request(`applications/${applicationId}/state-medicaid/save`, 'POST', payload)
    return res
}

export const getStateMedicaidSavedRecords = ({ applicationId }) => async () => {
    const res = await request(`applications/${applicationId}/state-medicaid/records`, 'GET')
    return res
}

export const deleteStateMedicaidSavedRecord = ({ applicationId, recordId }) => async () => {
    const res = await request(`applications/${applicationId}/state-medicaid/records/${recordId}`, 'DELETE')
    return res
}

export const getAllStatesSavedRecords = (applicantionId, pagination = {}) => async () => {
    const res = await request(
        `applications/${applicantionId}/sos/all-states/records`,
        'GET',
        null,
        true,
        {
            'x-pagination-num': pagination.page || 0,
            'x-pagination-limit': pagination.limit || 5
        }
    )
    return res
}

export const getAllStatesSearchHistory = ({ applicantId, pagination = {} }) => async () => {
    const res = await request(
        `applications/${applicantId}/sos/all-states-search`,
        'GET',
        null,
        true,
        {
            'x-pagination-num': pagination.page || 0,
            'x-pagination-limit': pagination.limit || 5
        }
    )
    return res
}

// get all states search status
export const getAllStatesSearchStatus = (applicantId) => async () => {
    const res = await request(`applications/${applicantId}/sos/all-states-search/status`, 'GET')
    return res
}

export const dispatchSosRecord = (record) => async (dispatch) => {
    dispatch(dispatchSosData(record))
}

export const resetSosData = () => async (dispatch) => {
    dispatch(dispatchSosData({}))
}

// update Summary
export const updateSummary = () => async (dispatch) => {
    dispatch(dispatchUpdateSummaryCard())
}

// update Direct Amendments
export const updateDirectAmendments = () => async (dispatch) => {
    dispatch(dispatchUpdateDirectAmendments())
}

export const getUccAuditData = ({ applicationId, params, pagination = {} }) => async () => {
    return await request(
        `applications/${applicationId}/ucc/audit`,
        'GET',
        null,
        true,
        {
            'x-pagination-num': pagination.page || 0,
            'x-pagination-limit': pagination.limit || 5
        },
        params
    )
}

export const createDemoApplication = () => {
    const res = request('applications/demo', 'POST', null, false, {"x-demo-mode": true})
    return res
}

export const requestMemo = (applicationId, isDemoMode=false) => async () => {
    const res = await request(`openai/memo`, 'POST', { applicationId }, false, { 'x-demo-mode': isDemoMode })
    return res
}

export const requestCreditMemo = (applicationId, isDemoMode=false) => async () => {
    // silentOnError=true because the CreditMemo tab handles its own retry-on-500
    // and only surfaces a toast if both attempts fail.
    const res = await request(`openai/memo/v2`, 'POST', { applicationId }, false, { 'x-demo-mode': isDemoMode }, undefined, true, true)
    return res
}

export const getCreditMemo = (applicationId, isDemoMode=false) => async () => {
    const res = await request(`openai/memo/v2/${applicationId}`, 'GET', null, false, { 'x-demo-mode': isDemoMode })
    return res
}

export const updateCreditMemoSummary = (applicationId, summary, isDemoMode=false) => async () => {
    const res = await request(`applications/${applicationId}/credit-memo/v2`, 'POST', { summary }, false, { 'x-demo-mode': isDemoMode })
    return res
}

export const getCreditMemoApproval = (applicationId) => async () => {
    // silentOnError: the tab shows its own message instead of a toast when approval data can't be loaded.
    return await request(`applications/${applicationId}/credit-memo/approval`, 'GET', null, false, {}, undefined, false, true)
}

export const getCreditMemoApprovers = (applicationId) => async () => {
    return await request(`applications/${applicationId}/credit-memo/approvers`, 'GET')
}

export const requestCreditMemoApproval = (applicationId, approverUserIds) => async () => {
    return await request(`applications/${applicationId}/credit-memo/approval-requests`, 'POST', { approverUserIds })
}

export const approveCreditMemoVersion = (applicationId, versionId) => async () => {
    return await request(`applications/${applicationId}/credit-memo/versions/${versionId}/approve`, 'POST', { attest: true })
}

// The requester approves a version every approver signed; this creates the signed PDF.
export const finalizeCreditMemoVersion = (applicationId, versionId) => async () => {
    return await request(`applications/${applicationId}/credit-memo/versions/${versionId}/finalize`, 'POST')
}

export const returnCreditMemoVersion = (applicationId, versionId, comment) => async () => {
    return await request(`applications/${applicationId}/credit-memo/versions/${versionId}/return`, 'POST', { comment })
}

export const withdrawCreditMemoVersion = (applicationId, versionId) => async () => {
    return await request(`applications/${applicationId}/credit-memo/versions/${versionId}/withdraw`, 'POST', {})
}

// fileName: see tools/creditMemoFileName (the backend sends the same name, when the browser may read it)
export const downloadCreditMemoPdf = (applicationId, fileName) =>
    downloadFile(`applications/${applicationId}/credit-memo/pdf`, 'GET', null, fileName)

export const downloadCreditMemoVersionPdf = (applicationId, versionId, fileName) =>
    downloadFile(`applications/${applicationId}/credit-memo/versions/${versionId}/pdf`, 'GET', null, fileName)

export const getCreditMemoPdf = (applicationId) =>
    getPDF(`applications/${applicationId}/credit-memo/pdf`)

export const getCreditMemoVersionPdf = (applicationId, versionId) =>
    getPDF(`applications/${applicationId}/credit-memo/versions/${versionId}/pdf`)

export const updateCreditMemoRiskScore = (applicationId, payload, isDemoMode=false) => async () => {
    const res = await request(`openai/memo/${applicationId}/risk-score`, 'POST', payload, false, { 'x-demo-mode': isDemoMode })
    return res
}

export const getAllDataStatus = (roxAppId) => async (dispatch) => {
    const res = await request(
        `applications/${roxAppId}/get-all-data/status`,
        'GET'
    );
    dispatch(dispatchAllDataStatus(res));
    return res;
};

// Silent so the caller can read the response body and surface the DocuSign error itself (a non-silent
// request consumes the body to toast it raw, leaving nothing for the caller to parse).
export const sendToDocusign = (applicantId) => async () => {
    const res = await request(`applications/${applicantId}/send-to-docusign`, 'POST', undefined, false, {}, undefined, true, true)
    return res
}

export const getTermsData = (applicantId) => async () => {
    const res = await request(`applications/${applicantId}/terms`, 'GET')
    return res
}

export const getFCTermsDetailById = (termId) => async () => {
    const res = await request(`factorCloud/terms/${termId}`, 'GET')
    return res
}

export const getAllFactorCloudTerms = () => async () => {
    // Best-effort load-time fetch: silent so a missing/unconfigured FactorCloud does not toast on tab open.
    const res = await request(`factorCloud/terms`, 'GET', undefined, false, {}, undefined, true, true)
    return res
}

export const retryFactorCloudOnboarding = (applicationUuid) => async () => {
    const res = await request(`applications/${applicationUuid}/factorCloud/retry-onboarding`, 'POST')
    return res
}

export const getAllDocusignTemplates = () => async () => {
    // Best-effort load-time fetch: silent so a client without DocuSign configured does not toast on tab open.
    // The real error is surfaced when the user actually sends to DocuSign.
    const res = await request(`docusign/template`, 'GET', undefined, false, {}, undefined, true, true)
    return res
}

export const submitTermsData = (applicantId, formData) => async () => {
    const res = await request(`applications/${applicantId}/terms`, 'POST', formData)
    return res
}

export const getCreditCostsOverview = (roxAppId) => async () => {
    const res = await request(`credit-costs/overview/${roxAppId}`, 'GET')
    return res
}

export const getCreditMemoExecutiveSummary = (applicationId) => async () => {
    const res = await request(`applications/${applicationId}/credit-memo/v2`, 'GET')
    return res
}

// Get credit memo status
export const getCreditMemoStatus = (roxAppId) => async () => {
    const res = await request(`openai/memo/${roxAppId}/v2/status`, 'GET')
    return res
}

// AR Balance 
export const requestArBalanceAnalysis = (applicationId, isDemoMode=false) => async () => {
    const res = await request(`doc-insights/applications/${applicationId}/ar-balance/analyze`, 'POST', null, false, { 'x-demo-mode': isDemoMode })
    return res
}

export const getArBalanceStatus = (roxAppId) => async () => {
    const res = await request(`applications/${roxAppId}/ar-balance/status`, 'GET')
    return res
}

export const getArBalance = (applicationId, isDemoMode=false) => async () => {
    const res = await request(`applications/${applicationId}/ar-balance`, 'GET', null, false, { 'x-demo-mode': isDemoMode })
    return res
}

export const getPreviousArBalance = (applicationId, isDemoMode=false) => async () => {
    const res = await request(`applications/${applicationId}/ar-balance/previous`, 'GET', null, false, { 'x-demo-mode': isDemoMode })
    return res
}

export const uploadArBalanceDocument = (applicationId, file) => async () => {
    const formData = new FormData()
    formData.append('file', file)
    
    const res = await request(`applications/${applicationId}/ar-balance`, 'POST', formData, false, {
        'Content-Type': 'multipart/form-data'
    })
    return res
}

export const requestArBalanceComparison = (applicationId) => async () => {
    const res = await request(`applications/${applicationId}/ar-balance/compare`, 'POST')
    return res
}

export const getArBalanceComparison = (applicationId) => async () => {
    const res = await request(`applications/${applicationId}/ar-balance/compare`, 'GET')
    return res
}

export const getLastBankDoc = (applicationId) => async () => {
    const res = await request(`applications/${applicationId}/bank-docs`, 'GET', null, false, {}, undefined, false)
    return res
}

export const getPreviousBankDoc = (applicationId) => async () => {
    const res = await request(`applications/${applicationId}/bank-docs/previous`, 'GET', null, false, {}, undefined, false)
    return res
}

export const getBankDocStatus = (applicationId) => async () => {
    const res = await request(`applications/${applicationId}/bank-docs/status`, 'GET', null, false, {}, undefined, false)
    return res
}

export const requestBankDocComparison = (applicationId) => async () => {
    const res = await request(`applications/${applicationId}/bank-docs/compare`, 'POST', null, false, {}, undefined, false)
    return res
}

export const getBankDocComparison = (applicationId) => async () => {
    const res = await request(`applications/${applicationId}/bank-docs/compare`, 'GET', null, false, {}, undefined, false)
    return res
}

export const uploadBankDoc = (applicationId, file) => async () => {
    const formData = new FormData()
    formData.append('file', file)

    const res = await request(`applications/${applicationId}/bank-docs`, 'POST', formData, false, {
        'Content-Type': 'multipart/form-data'
    }, undefined, false)
    return res
}

export const getLastBalanceSheet = (applicationId) => async () => {
    const res = await request(`applications/${applicationId}/balance-sheet`, 'GET', null, false, {}, undefined, false)
    return res
}

export const getPreviousBalanceSheet = (applicationId) => async () => {
    const res = await request(`applications/${applicationId}/balance-sheet/previous`, 'GET', null, false, {}, undefined, false)
    return res
}

export const getBalanceSheetStatus = (applicationId) => async () => {
    const res = await request(`applications/${applicationId}/balance-sheet/status`, 'GET', null, false, {}, undefined, false)
    return res
}

export const requestBalanceSheetComparison = (applicationId) => async () => {
    const res = await request(`applications/${applicationId}/balance-sheet/compare`, 'POST', null, false, {}, undefined, false)
    return res
}

export const getBalanceSheetComparison = (applicationId) => async () => {
    const res = await request(`applications/${applicationId}/balance-sheet/compare`, 'GET', null, false, {}, undefined, false, true)
    return res
}

export const uploadBalanceSheet = (applicationId, file) => async () => {
    const formData = new FormData()
    formData.append('file', file)

    const res = await request(`applications/${applicationId}/balance-sheet`, 'POST', formData, false, {
        'Content-Type': 'multipart/form-data'
    }, undefined, false)
    return res
}

export const getLastIncomeStatement = (applicationId) => async () => {
    const res = await request(`applications/${applicationId}/income-statement`, 'GET', null, false, {}, undefined, false)
    return res
}

export const getPreviousIncomeStatement = (applicationId) => async () => {
    const res = await request(`applications/${applicationId}/income-statement/previous`, 'GET', null, false, {}, undefined, false)
    return res
}

export const getIncomeStatementStatus = (applicationId) => async () => {
    const res = await request(`applications/${applicationId}/income-statement/status`, 'GET', null, false, {}, undefined, false)
    return res
}

export const requestIncomeStatementComparison = (applicationId) => async () => {
    const res = await request(`applications/${applicationId}/income-statement/compare`, 'POST', null, false, {}, undefined, false)
    return res
}

export const getIncomeStatementComparison = (applicationId) => async () => {
    const res = await request(`applications/${applicationId}/income-statement/compare`, 'GET', null, false, {}, undefined, false, true)
    return res
}

export const uploadIncomeStatement = (applicationId, file) => async () => {
    const formData = new FormData()
    formData.append('file', file)

    const res = await request(`applications/${applicationId}/income-statement`, 'POST', formData, false, {
        'Content-Type': 'multipart/form-data'
    }, undefined, false)
    return res
}

export const getLastCashFlowStatement = (applicationId) => async () => {
    const res = await request(`applications/${applicationId}/cash-flow-statement`, 'GET', null, false, {}, undefined, false)
    return res
}

export const uploadCashFlowStatement = (applicationId, file) => async () => {
    const formData = new FormData()
    formData.append('file', file)

    const res = await request(`applications/${applicationId}/cash-flow-statement`, 'POST', formData, false, {
        'Content-Type': 'multipart/form-data'
    }, undefined, false)
    return res
}

export const lookupTaxrock = (applicationId, businessEin, isDemoMode = false) => async () => {
    const ein = String(businessEin || '').replace(/\D/g, '')
    const res = await request(`applications/${applicationId}/taxrock/lookup`, 'POST', { businessEin: ein }, false, { 'x-demo-mode': isDemoMode }, undefined, false, true)
    return res
}

export const saveTaxrockRecord = (applicationId, payload) => async () => {
    const body = { ...payload, businessEin: String(payload?.businessEin || '').replace(/\D/g, '') }
    const res = await request(`applications/${applicationId}/taxrock/save`, 'POST', body, false, {}, undefined, false)
    return res
}

export const deleteTaxrockRecord = (applicationId, recordId) => async () => {
    const res = await request(`applications/${applicationId}/taxrock/records/${recordId}`, 'DELETE', null, false, {}, undefined, false)
    return res
}
export const getTaxrockRecords = (applicationId) => async () => {
    const res = await request(`applications/${applicationId}/taxrock/records`, 'GET', null, false, {}, undefined, false)
    return res
}

export const getCreditCosts = () => async () => {
    const res = await request(`credit-costs`, 'GET')
    return res
}

// Refresh an existing background report
export const refreshBgvReport = (applicantId, payLoad, isDemoMode = false) => async (dispatch) => {
    const res = await request(`applications/${applicantId}/backgroundVerification/refresh`, 'POST', payLoad, false, { 'x-demo-mode': isDemoMode }, undefined, false, true)
    const isBusiness = Object.keys(payLoad)[0] === 'businessId'
    if (isBusiness) {
        const data = res?.response?.TopBusinessReportResponseEx?.response?.Businesses?.Business[0] || {}
        dispatch(dispatchDetailedBusinessReport(data))
    } else {
        const data = res?.response?.BpsReportResponseEx?.response?.Individual || {}
        dispatch(dispatchBgvSearchResult(data))
    }
    return res
}

// Get report history for an entity
export const getBgvReportHistory = (applicantId, entityId, dba = false) => async () => {
    const res = await request(`applications/${applicantId}/backgroundVerification/history?entityId=${entityId}&dba=${dba}`, 'GET')
    return res
}

// Notification email recipients (admin) — one shared list drives self-register, plan-change,
// and state-medicaid digests. Each row is toggled per notification type via boolean flags.

export const getNotificationEmails = () => async () => {
    const res = await request(`admin/notification-emails`, 'GET')
    return res
}

export const createNotificationEmail = (payload) => async () => {
    // payload: { email, notifyOnRegistration, notifyOnPlanChange, notifyOnDsIngest }
    const res = await request(`admin/notification-emails`, 'POST', payload)
    return res
}

export const updateNotificationEmail = (payload) => async () => {
    // payload: { email, enabled, notifyOnRegistration, notifyOnPlanChange, notifyOnDsIngest }
    const res = await request(`admin/notification-emails`, 'PATCH', payload)
    return res
}

// Email templates (admin): every email the platform sends, previewed with sample data.

// No 404 redirect: the page shows its own retry state
export const getEmailTemplates = () => request(`admin/email-templates`, 'GET', null, false, {}, undefined, false)

export const previewEmailTemplate = (key, variant) =>
    request(`admin/email-templates/${encodeURIComponent(key)}/preview`, 'GET', null, false, {}, { variant }, false)

export const getDscr = (applicationId) => async () => {
    const res = await request(`applications/${applicationId}/dscr`, 'GET', null, false, {}, undefined, false)
    return res
}
